<div class="screen-size-container">
    <slot />
</div>

<style>
    .screen-size-container {
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
